import { observer } from 'mobx-react'
import { ReactComponent as Vector } from '../../../../assets/about/bg-markets.svg'
import ContentState from '../../../../stores/ContentState'
import './index.scss'

const KeyMarkets = observer(() => {
  const cnt = ContentState
  const content = cnt?.about?.keymarkets

  return (
    <section className="key-markets">
      <Vector className="key-markets__bg" />
      <div className="key-markets__container">
        <div
          className="key-markets__title"
          dangerouslySetInnerHTML={{ __html: content.title || '' }}
        ></div>
        <div className="key-markets__list">
          {content?.list?.map((arr: any, i: number) => (
            <div className="key-markets__col" key={i}>
              {arr?.map((li: any, id: number) => (
                <a className="key-markets__item" key={id} href={li.link}>
                  <img src={li.icon} />
                  {li.title}
                </a>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
})

export default KeyMarkets
